import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ClockIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M10.3449 10.2115C10.7378 10.3425 11.1626 10.1301 11.2935 9.73717C11.4245 9.34421 11.2122 8.91947 10.8192 8.78849L10.3449 10.2115ZM8.33203 8.75H7.58203C7.58203 9.07282 7.7886 9.35943 8.09486 9.46151L8.33203 8.75ZM9.08203 5.61391C9.08203 5.1997 8.74624 4.86391 8.33203 4.86391C7.91782 4.86391 7.58203 5.1997 7.58203 5.61391H9.08203ZM10.8192 8.78849L8.5692 8.03849L8.09486 9.46151L10.3449 10.2115L10.8192 8.78849ZM9.08203 8.75V5.61391H7.58203V8.75H9.08203ZM13.582 8C13.582 10.8995 11.2315 13.25 8.33203 13.25V14.75C12.06 14.75 15.082 11.7279 15.082 8H13.582ZM8.33203 13.25C5.43254 13.25 3.08203 10.8995 3.08203 8H1.58203C1.58203 11.7279 4.60411 14.75 8.33203 14.75V13.25ZM3.08203 8C3.08203 5.1005 5.43254 2.75 8.33203 2.75V1.25C4.60411 1.25 1.58203 4.27208 1.58203 8H3.08203ZM8.33203 2.75C11.2315 2.75 13.582 5.1005 13.582 8H15.082C15.082 4.27208 12.06 1.25 8.33203 1.25V2.75Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

ClockIcon.displayName = 'ClockIcon';
